var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _path11, _circle3, _circle4, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanStatements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    x1: 83.42,
    y1: 50.02,
    x2: 97.91,
    y2: 50.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c3393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ad1c7c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    x1: 105.95,
    y1: 75.36,
    x2: 120.44,
    y2: 75.36,
    xlinkHref: "#SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    x1: 84.92,
    y1: 62.49,
    x2: 119.26,
    y2: 62.49,
    xlinkHref: "#SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    y1: 62.66,
    x2: 120.44,
    y2: 62.66,
    xlinkHref: "#SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    y1: 62.66,
    x2: 120.44,
    y2: 62.66,
    xlinkHref: "#SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c",
    y1: 62.66,
    x2: 120.44,
    y2: 62.66,
    xlinkHref: "#SVGID_0_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    d: "M52.05 23.56h81.31c4.96 0 9.03 3.93 9.03 8.72v103.03l-81.31.13V49.29",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    d: "M61.08 49.4H43.03v-17c0-4.79 4.06-8.72 9.02-8.72s9.03 3.92 9.03 8.72v17z",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.77 98.31h-7.48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M85.46 98.31h45.52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.77 105.66h-7.48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M85.46 105.66h45.52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.77 113.5h-7.48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M85.46 113.5h45.52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.77 120.85h-7.48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M85.46 120.85h45.52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "m MI_4L_gradient",
    cx: 90.66,
    cy: 50.02,
    r: 6.08,
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "p MI_4L_gradient",
    cx: 113.2,
    cy: 75.36,
    r: 6.08,
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "o MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M86.08 81.09l32.02-37.21"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "q MI_4L_gradient",
    cx: 90.66,
    cy: 50.02,
    r: 6.08,
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "n MI_4L_gradient",
    cx: 113.2,
    cy: 75.36,
    r: 6.08,
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "r MI_4L_gradient",
    stroke: "url(#SVGID_5_95dbfee3ec43fc3f71d7d19288d98cfc7eba8c0810fc1ac8627b6f6b6e923d9c)",
    d: "M86.08 81.09l32.02-37.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanStatements);
export default __webpack_public_path__ + "static/media/loanStatements.e399382da3545b85c28363d62edfd41b.svg";
export { ForwardRef as ReactComponent };